export default "__VITE_ASSET__Cy8o$43b__"